import "./styles.css";
//import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import About from "./components/About";
//import Error from "./components/Error";
import Contact from "./components/Contact";
import Projects from "./components/Projects";
import ScrollTop from "./components/ScrollTop";

function App() {
  const style = {
    margin: 0,
    padding: 0,
    background: "#000",
  };

  return (
    <>
      <div style={{ style }} className="Body">
        <NavBar />
        <ScrollTop />
        <Home />
        <About />
        <Projects />
        <Contact />

        <Footer />
      </div>
    </>
  );
}

export default App;
